
    <iframe [src]="url" width="100%" height="100%"></iframe>
  


// WEBPACK FOOTER //
// ./src/app/file.view.pdf.component.ts.FileViewPdfComponent.html